import React from "react"
import PropTypes from "prop-types"
import { Button, Title } from "@bw/bits"
import styled from "styled-components"
import { Link } from "gatsby"
import { breakpoints } from "../../../theme"

const StyledWrapper = styled.div`
  position: relative;
  max-width: 100%;
  display: flex;
  padding: 24px;
  box-shadow: 0px 0px 55px rgba(140, 137, 176, 0.23);
  background-color: var(--primary);
  overflow: hidden;

  @media (min-width: ${breakpoints.medium}px) {
    padding: 48px;
  }

  @media (min-width: ${breakpoints.large}px) {
    padding: 50px 75px 0 75px;
  }
`

const Decoration = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(50%, -10%);
  height: 1200px;
  width: 1200px;

  &:before {
    content: "";
    display: block;
    width: 900px;
    height: 600px;
    position: absolute;
    top: 100px;

    border-radius: 50%;
    background: radial-gradient(
      33.57% 46.34% at 50% 52.15%,
      var(--primary-dark) 0%,
      rgba(1, 2, 3, 0) 100%
    );
    opacity: 0.6;
    transform: matrix(0.35, -0.84, -1.09, -0.19, 0, 0);
  }

  &:after {
    content: "";
    display: block;
    width: 900px;
    height: 600px;
    position: absolute;

    border-radius: 50%;
    background: radial-gradient(
      33.57% 46.34% at 50% 52.15%,
      var(--primary-dark) 0%,
      rgba(1, 2, 3, 0) 100%
    );
    transform: matrix(0.83, 0.44, 0.64, -0.86, 0, 0);
  }
`

const StyledLink = styled(Link)`
  text-decoration: none;
`

const StyledA = styled.a`
  text-decoration: none;
`

const StyledCtA = styled.div`
  justify-content: space-between;
  width: 100%;
  z-index: 5;
  color: ${props => (props.textColor === "positive" ? "#000000" : "#ffffff")};
  @media (min-width: ${breakpoints.medium}px) {
    display: flex;
    align-items: center;
    gap: 30px;
  }
`

const CallToAction = ({
  suptitle,
  title,
  subtitle,
  buttonLabel,
  to,
  href,
  onClick,
  textColor,
}) => {
  const Cta = ({ onClickEvent }) => (
    <StyledWrapper onClick={onClickEvent}>
      <StyledCtA textColor={textColor}>
        <Title suptitle={suptitle} title={title} subtitle={subtitle} negative />
        {buttonLabel && <Button label={buttonLabel} primary inversed />}
      </StyledCtA>
      <Decoration />
    </StyledWrapper>
  )

  switch (true) {
    case typeof to !== "undefined":
      return (
        <StyledLink to={to}>
          <Cta />
        </StyledLink>
      )

    case typeof href !== "undefined":
      return (
        <StyledA href={href} target="_blank" rel="noreferrer">
          <Cta />
        </StyledA>
      )

    case typeof onClick !== "undefined":
      return <Cta onClickEvent={onClick} />

    default:
      return <Cta />
  }
}

CallToAction.propTypes = {
  suptitle: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  buttonLabel: PropTypes.string,
  to: PropTypes.string,
  href: PropTypes.string,
  onClick: PropTypes.func,
  textColor: PropTypes.oneOf(["positive", "negative"]),
}

CallToAction.defaultProps = {
  textColor: "negative",
}

export { CallToAction }
